import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Apps from '../components/Apps';
import Pillars from '../components/Pillars';
import About from '../components/About';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useLanguage } from '../i18n/LanguageContext';

const HomePage = () => {
  const { t } = useLanguage();
  useScrollAnimation();

  return (
    <>
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
      </Helmet>

      <Hero />
      <Stats />
      <Apps />
      <Pillars />
      <About />
    </>
  );
};

export default HomePage;
